// This page for contact. 

import Contact from "../components/Contact";

const ContactMe = () => {
    return (
        <div className="pt-[64px] pb-[128px] lg:py-[192px] bg-navbarcolor min-h-[calc(100vh-72px-356px)]">
            <Contact />
        </div>
    )
}

export default ContactMe;